import type {TeamRoleId} from '../src/team';
import documents from 'virtual:role-instructions';
import {APP_BASE, Link} from './router';

/** The profile generator emits headings, paragraphs, and flat instruction lists. */
function InstructionDocument({source}: {source: string}) {
  return <div className="agent-instruction-text">{source.trimEnd().split(/\n\n+/).map((block, index) => {
    if (block.startsWith('# ')) return <h3 key={index}>{block.slice(2)}</h3>;
    if (block.startsWith('## ')) return <h4 key={index}>{block.slice(3)}</h4>;
    if (block.startsWith('- ')) return <ul key={index}>{block.split('\n').map((line, lineIndex) => <li key={lineIndex}>{line.slice(2)}</li>)}</ul>;
    return <p key={index}>{block}</p>;
  })}</div>;
}

export function RoleInstructions({roleId}: {roleId: TeamRoleId}) {
  const files = documents[roleId];
  if (!files?.soul || !files.agents) throw new Error(`The complete role instructions are missing for ${roleId}.`);
  return <section className="agent-role-instructions" aria-labelledby="role-instructions-heading">
    <h2 id="role-instructions-heading">Agent configuration</h2>
    <p className="agent-instructions-intro">These are the current default role files. Your account uses its saved copies, which can differ from these files. Shared account instructions and runtime settings also apply.</p>
    <div className="agent-instruction-links">
      <a href={`data:text/markdown;charset=utf-8,${encodeURIComponent(files.soul)}`} download={`${roleId}-SOUL.md`}>Download SOUL.md</a>
      <a href={`data:text/markdown;charset=utf-8,${encodeURIComponent(files.agents)}`} download={`${roleId}-AGENTS.md`}>Download AGENTS.md</a>
      <Link href={`${APP_BASE}/files`}>Read your account’s instructions</Link>
    </div>
    <section className="agent-role-document" aria-label="SOUL.md"><p className="agent-page-eyebrow">SOUL.md · Identity and conduct</p><InstructionDocument source={files.soul}/></section>
    <section className="agent-role-document" aria-label="AGENTS.md"><p className="agent-page-eyebrow">AGENTS.md · Work instructions</p><InstructionDocument source={files.agents}/></section>
  </section>;
}
